<template>
    <div class="kinship-wrapper">
        <div v-if="isShowTitle" class="mb20 fb">{{title}}</div>
        <avue-crud :data="data" v-if="orderId" :option="option" v-model="form" :table-loading="loading" ref="crud" @row-update="rowUpdate" @on-load="onLoad" :before-open="beforeOpen" @error="error">
            <template slot-scope="{row}" slot="orderId">
                <div class="num-family">{{row.orderId}}</div>
            </template>
            <template slot-scope="{row}" slot="orderInitNo">
                <div class="num-family">{{row.orderInitNo}}</div>
            </template>
            <template slot-scope="{row}" slot="menu">
                <el-button icon="el-icon-edit" size="mini" type="text" @click="dispatchHandle(row)">{{row.planStatus==0?'手动派单':row.planStatus==1?'已完成流转派单':'重新派单'}}</el-button>
            </template>
        </avue-crud>
        <avue-crud :data="data" v-if="!orderId" :option="option" v-model="form" :table-loading="loading" :page.sync="page" ref="crud" @row-update="rowUpdate" @on-load="onLoad" :before-open="beforeOpen" @error="error">
            <template slot-scope="{row}" slot="orderId">
                <div class="num-family">{{row.orderId}}</div>
            </template>
            <template slot-scope="{row}" slot="orderInitNo">
                <div class="num-family">{{row.orderInitNo}}</div>
            </template>
        </avue-crud>
        <div class="tac mt15" slot>
            <!-- <el-button type="primary" size="mini" icon="el-icon-plus" v-if="isShowBtn" @click="$refs.crud.rowAdd()">{{addBtnTitle}}</el-button> -->
            <el-button type="primary" size="mini" v-if="isShowBtn && !expire" @click="dispatchVisible = true">自动派单</el-button>
            <slot></slot>
        </div>
        <el-dialog title="自动派单" append-to-body :visible.sync="dispatchVisible">
            <avue-form :option="dispatchOption" v-model="dispatchForm" @submit="submitDispatch">
            </avue-form>
        </el-dialog>
    </div>
</template>
<script>
import { remove, update, add } from "@/api/order/orderinit";
import { getPublishList, autoPlanHandle, allocationHandle } from "@/api/order/index";
import { mapGetters } from "vuex";
import { cardid, isvalidatemobile } from '@/util/validate'
import { dateFormat } from "@/util/date"
import website from '@/config/website';
export default {
    props: {
        isShowTitle: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: '派单'
        },
        isShowBtn: {
            type: Boolean,
            default: true
        },
        addBtnTitle: {
            type: String,
            default: '添加机构'
        },
        orderId: {
            type: String,
            default: ''
        },
        list: {
            type: Array
        },
        isOpt: {
            type: Boolean,
            default: true
        },
        orderInitialPlanList: {
            type: Array,
            default: () => []
        },
        expire: {
            type: Boolean,
            default: false
        }
    },
    data() {
        var checkCardid = (rule, value, callback) => {
            let list = cardid(value);
            if (list[0]) {
                return callback(new Error(list[1]));
            } else {
                callback();
            }
        };
        var checkPhone = (rule, value, callback) => {
            let list = isvalidatemobile(value);
            if (list[0]) {
                return callback(new Error(list[1]));
            } else {
                callback();
            }
        };

        return {
            dispatchVisible: false,
            dispatchForm: {},
            dispatchOption: {
                size: 'mini',
                labelWidth: 120,
                column: [{
                        label: "派单范围",
                        prop: "planScope",
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        row: true,
                        span: 24,
                        dicQuery: {
                            code: 'range_type'
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        rules: [{
                            required: true,
                            trigger: "blur"
                        }]
                    },
                    {
                        label: "派单人姓名",
                        prop: "initPlanUser",
                        type: 'select',
                        dicUrl: "/api/blade-order/order/getPublishUserList",
                        props: {
                            label: "userName",
                            value: "userId"
                        },
                        rules: [{
                            required: true,
                            message: "请选择发布人",
                            trigger: "change"
                        }],
                        row: true,
                        span: 24,
                        change: ({ value }) => {
                            getPublishList().then(res => {
                                let obj = res.data.data.find(v => v.userId == value)
                                if (obj) this.dispatchForm.initPlanUserName = obj.userName
                            })
                        }
                    }, {
                        label: '派单时间',
                        prop: 'planTime',
                        row: true,
                        type: 'date',
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                        span: 24,
                        value: this.getDateFormate(),
                        rules: [{
                            required: true,
                            message: "请选择时间",
                            trigger: "change",
                        }]
                    },
                    {
                        label: '计划完成时间',
                        prop: 'endTime',
                        row: true,
                        type: 'date',
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                        span: 24,
                        rules: [{
                            required: true,
                            message: "请选择时间",
                            trigger: "change",
                        }]
                    }
                ]
            },
            form: {},
            loading: true,
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            data: [],
            option: {
                size: 'mini',
                border: true,
                align: 'center',
                menuAlign: 'center',
                delBtn: false,
                viewBtn: false,
                addBtn: false,
                cellBtn: false,
                columnBtn: false,
                refreshBtn: false,
                editBtn: false,
                // editBtnText: '手动派单',
                updateBtnText: '派单',
                menuBtn: false,
                labelWidth: 120,
                menu: this.isOpt,
                column: [{
                        label: '计划单编号',
                        prop: 'orderInitNumber',
                        row: true,
                        span: 24,
                        disabled: true,
                        rules: [{
                            required: true,
                            message: "请输入计划单编号",
                            trigger: "blur"
                        }]
                    },
                    {
                        label: '执行内容',
                        prop: 'type',
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        // showAllLevels: false,
                        // dataType: 'string',
                        // emitPath: false,
                        dicQuery: {
                            code: "work_type"
                        },
                        formatter: (row, value, label, column) => {
                            return label
                        },
                        // props: {
                        //     label: "title",
                        //     value: "value"
                        // },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        row: true,
                        disabled: true,
                        span: 24,
                        rules: [{
                            required: true,
                            trigger: "blur"
                        }]
                    },
                    {
                        label: "执行机构",
                        prop: "initPlanCreateDept",
                        dataType: 'string',
                        type: 'tree',
                        checkStrictly: true,
                        leafOnly: false,
                        filterable: true,
                        dicUrl: "/api/blade-system/dept/tree",
                        props: {
                            label: 'title'
                        },
                        formatter: (row, value, label, column) => {
                            if (value == -1) {
                                return ""
                            }
                            return label
                        },
                        rules: [{
                            required: true,
                            message: "请选择机构",
                            trigger: "click"
                        }],
                        change: ({ value }) => {
                            if (value == -1 || !value) {
                                this.form.initPlanCreateDept = ''
                            }
                        }
                    },
                    {
                        label: "派单人",
                        prop: "initPlanUser",
                        type: "tree",
                        dicUrl: "/api/blade-order/order/getPublishUserList",
                        searchOrder: 2,
                        span: 24,
                        props: {
                            label: "userName",
                            value: "userId"
                        },
                        formatter: (row, value, label, column) => {
                            if (value == -1 || !value) {
                                return ""
                            } else {
                                return label
                            }
                        },
                    },
                    {
                        label: '派单时间',
                        prop: 'planTime',
                        row: true,
                        type: 'date',
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                        span: 24,
                        value: this.getDateFormate(),
                        rules: [{
                            required: true,
                            message: "请选择时间",
                            trigger: "change",
                        }]
                    },
                    {
                        label: '计划完成时间',
                        prop: 'expectTime',
                        row: true,
                        type: 'date',
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                        span: 24,
                        rules: [{
                            required: true,
                            message: "请选择时间",
                            trigger: "change",
                        }]
                    }
                ]
            }
        }
    },
    watch: {
        orderId() {
            this.form.orderId = this.orderId
        },
        list: {
            deep: true,
            handler(val) {
                this.data = this.list
            }
        }
    },
    computed: {
        ...mapGetters(["userInfo"])
    },
    mounted() {
        this.form.createUser = this.userInfo.user_id
    },
    methods: {
        getDateFormate() {
            return dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss")
        },
        dispatchHandle(row) {
            if (row.planStatus == 1) {
                this.$message.error("当前计划单单已经派过了!")
            } else {
                setTimeout(() => {
                    row.initPlanUser = this.userInfo.user_id
                    row.planTime = this.getDateFormate()
                    this.$refs.crud.rowEdit(row)
                }, 300)

            }
        },
        rowUpdate(row, index, done, loading) {
            let obj = {
                expectTime: row.expectTime,
                initPlanCreateDept: row.initPlanCreateDept,
                initPlanCreateDeptName: row.$initPlanCreateDept,
                initPlanUser: row.initPlanUser,
                initPlanUserName: row.$initPlanUser,
                orderInitialPlanId: row.id,
                planTime: row.planTime,
            }
            allocationHandle(obj).then(res => {
                this.$message({
                    type: "success",
                    message: "手动派单成功!"
                });
                this.$set(this.data, index, row)
                this.$emit('getList', this.data)
                done(row);
            }).catch(error => {
                window.console.log(error);
                done();
            })
        },
        onLoad(page, params = {}) {
            this.loading = true;
            if ((this.list && this.list.length > 0) || !this.form.orderId) {
                this.data = this.list || []
                this.page.total = this.data.length;
                this.loading = false;
                return
            }
        },
        submitDispatch(form, done, loading) {
            form.orderId = this.orderId
            autoPlanHandle(form).then(res => {
                this.$message({
                    type: "success",
                    message: "已选择自动派单!"
                });
                this.dispatchVisible = false
                done();
            }).catch(() => {
                window.console.log(error);
                done();
            })
        },
        error(err) {
            this.$message.success('请填写完整信息');
        }
    }
}

</script>
<style>
.kinship-wrapper .avue-crud__menu {
    display: none !important;
}

</style>
